import { useState, useEffect, useRef } from "react";

const useDelayedIsOpen = (isOpen, onRequestClose, delay) => {
  const [overridenIsOpen, setOverridenIsOpen] = useState(false);
  const timeoutRef = useRef();

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    if (isOpen) {
      setTimeout(() => {
        setOverridenIsOpen(true);
      }, delay);
    }
  }, [isOpen, delay]);

  const delayedOnRequestClose = (event, ...rest) => {
    if (typeof event.persist === "function") {
      // see https://reactjs.org/docs/legacy-event-pooling.html for react < 17
      event.persist();
    }

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    setOverridenIsOpen(false);
    timeoutRef.current = setTimeout(() => {
      onRequestClose(event, ...rest);
    }, delay);
  };

  return [overridenIsOpen ?? isOpen, delayedOnRequestClose];
};

export default useDelayedIsOpen;
